export const contactsData = {
  email: 'shuklaayushkumar27@gmail.com',
  // phone: '+91 7518926897',
};
